(($) => {
    $('.filter')
        .on('filter-toggle-popover', (event) => {
            event.target.closest('.filter__item').append(event.currentTarget.getElementsByClassName('filter__popover')[0]);
        });
})($);
